{
  "recommendationAccepted": null,
  "numberOfDocumentsRequested": 0,
  "setCompletionDateForEmail": "",
  "opportunityOwnerTextForEmail": "John Woah",
  "ownerEmailAddress": "johnwoah@mojomortgages.com"
}